import styles from './TableFooter.module.css';

const TableFooterV2 = ({ range, setPage }) => {
  
  return (
    <div className={styles.tableFooter}>
      {range?.map((el, index) => (
        <button
          key={index}
          className={`${styles.button} ${
            el.active ? styles.activeButton : styles.inactiveButton
          }`}
          disabled={!el.url}
          onClick={() => {
            if (!el.url) return;
            const url = new URL(el.url);
            const page = url.searchParams.get("page");
            setPage(parseInt(page, 10));}}>
          {el.label}
        </button>
      ))}
    </div>
  );
};

export default TableFooterV2;
